import './App.css';
// import Header from "./components/Header"
import Navbar from "./components/Navbar"
import Cover from "./components/RowCover/Cover"
import Message from './components/RowMessage/Message';
import House from "./components/RowHouse/House"
import Facts from "./components/RowFacts/Facts"
import Retail from "./components/RowRetail/Retail"
// import ParallaxBack1 from './components/ParallaxBack1';
import { useEffect, useState } from 'react';
import ScrollTop from "./components/ScrollTop"
import NMV from "./components/RowNMV/NMV"
import GeoExtension from "./components/ROWextension/GeoExtension"
import UGC from "./components/RowUGC/UGC"
import MarketplaceRow from "./components/RowMarketplace/MarketplaceRow"
import RowOCT from "./components/RowOCT/RowOCT"
import ParallaxBack2 from './components/ParallaxBack2';
import RowCenters from "./components/RowCenters/RowCenters"
// import ParallaxBack3 from './components/ParallaxBack3';
import ParallaxBack4 from './components/ParallaxBack4';
import RowPromotion from './components/RowPromotion/RowPromotion';
import RowOTD from './components/RowOTD/RowOTD';
import RowBestQ from './components/RowBestQ/RowBestQ';
import RowBestNMV from './components/RowBestNMV/RowBestNMV';
import RowNewjoiners from './components/RowNewjoiners/RowNewjoiners';
import RowBestBrands from './components/RowBestBrands/RowBestBrands';
import ParallaxBack5 from './components/ParallaxBack5';
import RowCSRdomains from "./components/RowCSRdomains/RowCSRdomains"
import RowCSRdonations from "./components/RowCSRdonations/RowCSRdonations"
import RowEnd from "./components/RowEnd"
import RowBoomiMahalli from './components/RowBoomiMahalli/RowBoomiMahalli';

function App() {
  // hide the sticky navbar if not scrolled at least 400px
  const[show, setShow]= useState(false)
  useEffect(() => {
    const onScroll = e => {
      if (window.scrollY > 400 ){
        setShow(true)
      } else{
        setShow(false)
      }
    };
    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);

  });


  return (
    <div className="App">
      <ScrollTop />
      <Cover />
      <div id="Navb" className={show? "d-block":"d-none"}>
      <Navbar />      
      </div> 
      <Message />
      <House />
      {/* <ParallaxBack1 /> */}

      <Facts />
      <Retail />
      <NMV />
      <ParallaxBack2 />
      <GeoExtension />
      <RowCenters />
      <RowPromotion />
      <RowOTD />
      <RowOCT />

      <MarketplaceRow />
      <UGC />

      <RowNewjoiners />

      <ParallaxBack4 />
      <RowBestQ />
      <RowBestNMV />
      {/* <ParallaxBack3 /> */}

    <RowBestBrands />
    <ParallaxBack5 />
    <RowCSRdomains />
    <RowCSRdonations />
    <RowBoomiMahalli />
    <RowEnd />
    
    </div>
  );
}

export default App;
